module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/VacationsBookingFormWide.module.scss");